import {
  Box,
  Button,
  Stack,
  Typography
} from '@mui/material';
import {
  InviteUserModal,
  UserTable
} from 'modules';
import { useState } from 'react';
import { useParams } from 'react-router-dom';



export type ManageUsersSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ManageUsersSectionProps) => {
  const { organizationId } = useParams<{
    organizationId: string;
  }>();
  const [
    inviteIsVisible,
    setInviteIsVisible
  ] = useState(false);

  return (
    <>
      <Box
        display='flex'
        flexDirection='column'
      >
        <Box
          paddingBottom='1rem'
          bgcolor='white'
          borderRadius='1rem'
          paddingY='.75rem'
          paddingX='1.5rem'
        >

          <Stack
            direction='row'
            justifyContent='space-between'
            alignItems='center'
            paddingBottom='.5rem'
          >
            <Typography variant='activityHeader'>
              Users
            </Typography>

            <Button
              onClick={() => setInviteIsVisible(() => true)}
              variant='contained'
              color='primary'

            >
              Invite User
            </Button>
          </Stack>

          <UserTable.FC organizationId={organizationId} />
        </Box>
      </Box>

      {inviteIsVisible && (
        <InviteUserModal.FC
          organizationId={organizationId}
          isVisible={inviteIsVisible}
          onClose={() => setInviteIsVisible(() => false)}
        />
      )}
    </>
  );
};

